import { AUDIT_STATUSES, TASK_STATUSES } from "../constants/statuses.constants"

export const CLICKABLE_TASKS = {
  [TASK_STATUSES.DEAD]: true,
  [TASK_STATUSES.ERROR]: true
}

export const CLICKABLE_AUDITS = {
  [AUDIT_STATUSES.REQ]: true,
  [AUDIT_STATUSES.SENT]: true
}
